export default __webpack_public_path__ + "static/bg-green-2c9b4e0f241716afc898651d82c8dfce.jpg";